module.exports = __webpack_public_path__ + "img/placeholder.8f5b69d5.jpg";